// extracted by mini-css-extract-plugin
module.exports = {"Title":"videos_Title__kPn4Z","Item":"videos_Item__DjDLo","Videos":"videos_Videos__d7yOE"};